<template>
  <v-dialog v-model="showAlert" persistent width="550">
    <v-card class="pa-5 pb-7">
      <v-icon size="90" color="warning">mdi-alert-circle-outline</v-icon>

      <div v-if="text" class="grey--text text--darken-1 mt-5 mb-7">
        <p class="text-h6 mb-0">
          {{ text }}
        </p>
        <p class="text-subtitle-1 mb-0">Serás redirigido al incio.</p>
      </div>

      <v-btn class="red-button" @click="closeModal">Aceptar</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'CartAccrosTabsAlert',

    props: {
      value: Boolean,
      type: {
        type: String,
        required: true,
        validator: (val) =>
          ['multiple-carts', 'customer-changed'].includes(val),
      },
    },

    computed: {
      showAlert: {
        set(newValue) {
          this.$emit('update', newValue);
        },
        get() {
          return this.value;
        },
      },
      text() {
        if (this.type === 'multiple-carts') {
          return 'No es posible tener más de un carrito activo.';
        } else if (this.type === 'customer-changed') {
          return 'El cliente seleccionado fue cambiado desde otra pestaña.';
        }

        return '';
      },
    },

    methods: {
      closeModal() {
        this.showAlert = false;
        this.$router.push({ name: 'Home' });
      },
    },
  };
</script>
